import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  catchErrorAndEvict,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { SERVICE_MASTER_LIST } from '../../../graphql';
import { ServiceMasterListModel } from '../../../models';

@Injectable({ providedIn: 'root' })
export class ServiceMasterListService {
  private readonly apollo = inject(Apollo);

  private clientName = APOLLO_CLIENT_NAMES.contact;

  getServiceMasterList(): Observable<ServiceMasterListModel> {
    const fieldName =
      getQueryRootFieldName(SERVICE_MASTER_LIST) || 'masterServiceList';

    return this.apollo
      .use(this.clientName)
      .query({
        query: SERVICE_MASTER_LIST,
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result.data?.masterServiceList),
        catchErrorAndEvict(this.apollo, this.clientName, fieldName),
      );
  }
}
